// src/pages/Inicio.js
import React, { useEffect, useState } from "react";
import "../styles/inicio.css";

export default function Inicio() {
    const [cuentas, setCuentas] = useState([]);
    const [seleccionado, setSeleccionado] = useState(null);

    // Cargar textos UI (inicio.json)
    const [contenido, setContenido] = useState(null);
    const [cargandoContenido, setCargandoContenido] = useState(true);
    const [cargandoCuentas, setCargandoCuentas] = useState(true);
    const [errorContenido, setErrorContenido] = useState(false);
    const [errorCuentas, setErrorCuentas] = useState(false);

    // Helpers de rutas (soporta servir bajo subpath)
    const base = process.env.PUBLIC_URL || "";
    const urlInicio = `${base}/data/inicio.json`;
    const urlCuentas = `${base}/data/cuentasDonaciones.json`;

    useEffect(() => {
        let cancelado = false;
        (async () => {
            try {
                const rInicio = await fetch(urlInicio, { cache: "no-store" });
                if (!rInicio.ok) throw new Error("HTTP " + rInicio.status);
                const dataInicio = await rInicio.json();
                if (!cancelado) {
                    setContenido(dataInicio);
                    setCargandoContenido(false);
                    if (dataInicio?.seoTitle) document.title = dataInicio.seoTitle;
                }
            } catch (e) {
                if (!cancelado) {
                    setErrorContenido(true);
                    setCargandoContenido(false);
                }
                console.warn("[Inicio] Error cargando inicio.json:", e);
            }
        })();
        return () => { cancelado = true; };
    }, [urlInicio]);

    useEffect(() => {
        let cancelado = false;
        (async () => {
            try {
                const rCuentas = await fetch(urlCuentas, { cache: "no-store" });
                if (!rCuentas.ok) throw new Error("HTTP " + rCuentas.status);
                const dataCuentas = await rCuentas.json();
                if (!cancelado) {
                    const lista = Array.isArray(dataCuentas) ? dataCuentas : [];
                    setCuentas(lista);
                    setSeleccionado(lista.length ? lista[0].id : null);
                    setCargandoCuentas(false);
                }
            } catch (e) {
                if (!cancelado) {
                    setErrorCuentas(true);
                    setCargandoCuentas(false);
                }
                console.warn("[Inicio] Error cargando cuentasDonaciones.json:", e);
            }
        })();
        return () => { cancelado = true; };
    }, [urlCuentas]);

    // Textos de UI seguros incluso si inicio.json falló
    const ui = {
        loadingText: contenido?.ui?.loadingText || "Cargando…",
        loadError: contenido?.ui?.loadError || "No se pudo cargar la información...",
        noAccounts: contenido?.ui?.noAccounts || "Sin cuentas disponibles.",
        donacionesTitle: contenido?.ui?.donacionesTitle || "DONACIONES",
        cedulaLabel: contenido?.ui?.cedulaLabel || "Cédula Jurídica:",
        iconAltDefault: contenido?.ui?.iconAltDefault || "Icono",
    };

    // Prioriza errores visibles
    if (errorContenido) {
        return <p role="alert" style={{ padding: 20 }}>{ui.loadError}</p>;
    }
    if (cargandoContenido && !contenido) {
        return <p aria-busy="true" style={{ padding: 20 }}>{ui.loadingText}</p>;
    }
    if (!contenido) {
        return <p role="alert" style={{ padding: 20 }}>{ui.loadError}</p>;
    }

    const cuentaActiva = cuentas.find((cuenta) => cuenta.id === seleccionado);

    // Fondo hero del JSON
    const heroBg = { backgroundImage: `url(${base}/imgs/instalaciones/35.jpeg)` };

    return (
        <>
            {/* HERO */}
            <div className="hero-modernizado" style={heroBg}>
                <div className="hero-contenedor">
                    <h1 className="hero-titulo">
                        <span className="hero-linea1">{contenido.hero.titleLine1}</span>
                        <span className="hero-linea2">{contenido.hero.titleLine2}</span>
                    </h1>
                    <p className="hero-subtitulo">{contenido.hero.subtitle}</p>
                </div>
            </div>

            <hr className="separador" />

            {/* DONACIONES — debajo del hero (markup legacy con datos del JSON) */}
            <div className="modulo-donaciones-completo">
                <div className="donaciones-texto">
                    <h2 className="titulo-destacado">{ui.donacionesTitle}</h2>
                    <p className="donaciones-intro">{contenido.donaciones.intro}</p>
                    <p className="donaciones-intro">
                        <strong>{ui.cedulaLabel}</strong> {contenido.donaciones.cedulaJuridica}
                    </p>
                </div>

                <div className="donaciones-panel">
                    <div className="donaciones-tabs-horizontal" role="tablist" aria-label={ui.donacionesTitle}>
                        {cargandoCuentas ? (
                            <button className="donacion-tab-btn" disabled>{ui.loadingText}</button>
                        ) : errorCuentas ? (
                            <button className="donacion-tab-btn" disabled>{ui.loadError}</button>
                        ) : !cuentas.length ? (
                            <button className="donacion-tab-btn" disabled>{ui.noAccounts}</button>
                        ) : (
                            cuentas.map((cuenta) => (
                                <button
                                    key={cuenta.id}
                                    role="tab"
                                    aria-selected={cuenta.id === seleccionado}
                                    className={`donacion-tab-btn ${cuenta.id === seleccionado ? "activo" : ""}`}
                                    onClick={() => setSeleccionado(cuenta.id)}
                                >
                                    {cuenta.nombre}
                                </button>
                            ))
                        )}
                    </div>

                    <div className="donacion-tab-panel" role="region" aria-live="polite">
                        {cargandoCuentas ? (
                            <p>{ui.loadingText}</p>
                        ) : errorCuentas ? (
                            <p role="alert">{ui.loadError}</p>
                        ) : !cuentas.length ? (
                            <p>{ui.noAccounts}</p>
                        ) : (
                            cuentaActiva?.detalles?.map((item, index) => (
                                <div key={`${cuentaActiva.id}-${index}`} className="donacion-dato">
                                    <h4>{item.etiqueta}</h4>
                                    <p>{item.valor}</p>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>

            {/* CARDS (queda después de donaciones) */}
            <section className="cards-grid">
                {Array.isArray(contenido.cards) &&
                    contenido.cards.map((card, idx) => (
                        <article key={idx} className="card-item">
                            <div className="card-icono">
                                <img
                                    src={card.icon}
                                    alt={card.alt || ui.iconAltDefault}
                                    loading="lazy"
                                />
                            </div>
                            <h3 className="card-titulo">{card.title}</h3>
                            <p className="card-texto">{card.body}</p>
                        </article>
                    ))}
            </section>
        </>
    );
}
